import { IonActionSheet, IonContent, IonFooter, IonHeader, IonIcon, IonLoading, IonModal, IonPage, IonTitle, IonToolbar, withIonLifeCycle } from '@ionic/react';
import { checkmarkCircle, cardSharp, closeCircle, searchCircle, pieChart, cloudDone, download, duplicate, happy, heart, infiniteSharp, grid, lockClosedSharp, tv, albums, library, pricetags, checkmarkSharp, close, infinite, logoWhatsapp } from 'ionicons/icons';
import React from 'react';
//  import Logo from '../icons/logo.svg';
import Logo from '../images/icon-nopadding.png';
import SQLStorage from '../SQLStorage';
import '../styles/Subscription.scss';
import { isPlatform } from '@ionic/react';
import Utilities from '../Utilities.js';
import TeamSvg from '../images/team.svg';
import store from '../state/store';
import Server from '../Server';
import { updatedSetsSet } from '../state/actions/UpdatedSets';
import Bugsnag from '@bugsnag/js'
import { Device } from '@capacitor/device';

window.waitingForNewApprovedPurchasesTimeout = null;

class Subscription extends React.Component {

    constructor(props) {
        super(props);
        
        this.state = {
            loading: true,
            fullScreenLoading: false,
            deviceInfo: {},
            contactUsSheet: false,
            clickedRestore: false
        }
    }

    hashCode(s){
        return s.split("").reduce(function(a,b){a=((a<<5)-a)+b.charCodeAt(0);return a&a},0);              
    }

    async componentDidMount() {

        if (!window.db || !window.settings) {
            setTimeout(() => {
                this.componentDidMount();
            }, 50);
            return;
        }

        Utilities.trackEvent("Subscription", "Subscription Page View");
        // this.setState({ price: '$49.99', id: "simple_pro_lifetime", loading: false, priceCurrency: "$", priceNumeric: 50 });

        this.setState({
            loading: true,
        })

        let deviceInfo = await Device.getInfo();
        this.setState({ deviceInfo: deviceInfo }, function() {
            this.generateLicenceKey();
        })

        if (window.os === "ios" || window.os === "android") {
            this.loadProducts();
        } else {
            this.setState({
                notAvailableInApp: true
            })
        }

    }

    // async subscribe() {

    //     Utilities.trackEvent("Subscription", "Subscription Purchase Click");

    //     this.setState({ loading: true })

    //     window.inAppPurchase
    //         .buy("simple_pro_lifetime")
    //         .then(function(purchase) {
    //             Utilities.trackEvent("Subscription", "Subscription Purchase Done");
    //             Utilities.slack("Subscribed " + JSON.stringify(purchase));
    //             this.attempToRestore();
    //             window.toast("Purchase successful", "success")
    //         }.bind(this)).catch(function (err) {
    //             window.toast("Failed to restore purcahses: " + JSON.stringify(err), "error")
    //             Utilities.slack("Subscribed Error " + JSON.stringify(err));
    //             Utilities.trackEvent("Subscription", "Subscription Purchase Fail");
    //             this.setState({ loading: false })
    //         }.bind(this));

    // }

    async loadProducts() {

        console.log("loadProducts", window.store, window.validator);

        if (window.store) {

            window.store.register({ id: "simple_pro_yearly", type: window.store.PAID_SUBSCRIPTION });
            window.store.register({ id: "simple_pro_lifetime", type: window.store.NON_CONSUMABLE });

            window.store.error(function(error) {
                // if (isPlatform("android")) {
                    alert('Error loading product details ' + error.code + ': ' + error.message); // TODO remove
                    Bugsnag.notify(error);
                // }
                window.toast("Failed to load prices, make sure that you are connected to the internet.", "error")
                Utilities.slack("Failed to load prods " + error.code + " " + error.message)

                this.setState({
                    fullScreenLoading: false,
                })
            });

            window.store.when("simple_pro_yearly").updated(function(product) {
                console.log("info loaded", product)
                // if (window.debugging) {
                //     alert(product.price + " - " +  JSON.stringify(product))
                // }
                this.setState({ 
                    yearlyPrice: product.price, 
                    yearlyPriceNumeric: product.priceMicros/1000000, 
                    yearlyPriceCurrency: product.currency,
                    loading: false,
                }, () => {
                    console.log(JSON.parse(JSON.stringify(this.state)))
                })
            }.bind(this));

            window.store.when("simple_pro_lifetime").updated(function(product) {
                console.log("info loaded", product)
                this.setState({ 
                    lifetimePrice: product.price, 
                    lifetimePriceNumeric: product.priceMicros/1000000, 
                    lifetimePriceCurrency: product.currency,
                    loading: false,
                })
            }.bind(this));
    
            window.store.when().approved(async function(product) {
                if (!window.settings.account) {
                    this.promptLogin();
                    return;
                }

                this.setState({
                    fullScreenLoading: true,
                })

                clearTimeout(window.waitingForNewApprovedPurchasesTimeout);

                if (window.debugging) {
                    window.toast("Approved " + product.id);
                    // alert("APPROVE - " + JSON.stringify(product));
                }

                console.log("purchased approved", JSON.parse(JSON.stringify(product)), product.id, product.transaction.appStoreReceipt);

                if (window.os === "ios" && (!product.transaction || !product.transaction.appStoreReceipt)) { 
                    // if (window.debugging) {
                        window.alert("Failed to get receipt from purchase " + JSON.stringify(product));
                    // }
                }

                await Server.putPurcahse({
                    method: "put",
                    url: "user/purchase",
                    data: {
                        "appId": "com.dominikgyecsek.simplecards",
                        "purchaseId": product.transaction.id,
                        "productId": product.id,
                        "purchaseToken": window.os === "android" ? product.transaction.purchaseToken : product.transaction.appStoreReceipt,//  || product.transaction.purchaseToken,
                        "purchaseType": product.transaction.type,
                        "env": window.debugging ? "dev" : "live",
                        "data": product
                    }
                }).catch(function(err) {
                    if (window.debugging) {
                        alert("Failed to save purchase " + JSON.stringify(err));
                    }
                })

                window.waitingForNewApprovedPurchasesTimeout = setTimeout( async function() {
                    if (window.debugging) {
                        window.toast("Timeout for new purchases passed, redirecting", "success")
                    }

                    // await SQLStorage.saveSetting("licence", this.generateLicenceKey());
                    // await window.dropbox.queueForUpload("setting", "licence");

                    setTimeout(function() {
                        localStorage.setItem("preventAppOpenTrack", "true")
                        window.location.href = "/"
                    }, 1500);

                }.bind(this), 3000)

                if (window.debugging) {
                    window.toast("Purchase passed", "success");
                    // alert("Purchase passed " + JSON.stringify({
                    //     "appId": "com.dominikgyecsek.simplecards",
                    //     "purchaseId": product.transaction.id,
                    //     "productId": product.id,
                    //     "purchaseToken": window.os === "android" ? product.transaction.purchaseToken : product.transaction.appStoreReceipt,//  || product.transaction.purchaseToken,
                    //     "purchaseType": product.transaction.type,
                    //     "env": window.debugging ? "dev" : "live",
                    //     "data": product
                    // }));
                }
            }.bind(this));
    
            // window.store.when(window.productName).verified(function(c) {
            //     alert("Verified " + (c ? JSON.stringify(c) : null))
            // });
    
            window.store.refresh();

            // window.inAppPurchase
            // .getProducts(['simple_pro_lifetime'])
            // .then(function (products) {

            //     if (products && products[0]) {
            //         for (let i = 0; i < products.length; i++) {
            //             let product = products[i];
            //             if (product.productId === "simple_pro_lifetime") {
            //                 var priceNumeric = product.price.match(/\d/g).join("");
            //                 var priceCurrency = product.price.replace(priceNumeric + "", "");

            //                 this.setState({ price: product.price, priceNumeric: priceNumeric, priceCurrency: priceCurrency, id: "simple_pro_lifetime", loading: false })
            //             }
            //         }
            //     } else {
            //         window.toast("Failed to load prices, make sure that you are connected to the internet.", "error")
            //         Utilities.slack("Failed to load prods 1" + JSON.stringify(products || {}));
            //     }
    
            // }.bind(this)).catch(function (err) {
            //     Utilities.slack("Failed to load prods 2" + JSON.stringify(err || {}));
            //     window.toast("Failed to load prices, make sure that you are connected to the internet. " + JSON.stringify(err || {}), "error")
            // });

        }

    }

    async generateLicenceKey() {
        console.log(this.state.deviceInfo.uuid);
        const UUID_FIRST_PART = this.state.deviceInfo.uuid.substr(0, 4)
        const hash = this.hashCode(UUID_FIRST_PART).toString().substr(0, 4);
        return UUID_FIRST_PART + " " + hash;
    }

    promptLogin() {
        window.preventFocusBlurTrack = true;
        if(window.confirm(window.ln.loginForSubs || "Login or sign up to make or restore your purchases.")) {
            localStorage.setItem("auto-signup-tap", "true");
            localStorage.setItem("preventAppOpenTrack", "true")
            window.location.href = "/settings";
        }
        setTimeout(() => {
            window.preventFocusBlurTrack = false;
        }, 300);
    }

    async attempToRestore() {
        if (!window.settings.account) {
            this.promptLogin();
            return
        }
    
        this.setState({
            fullScreenLoading: true,
        })

        this.doPurchase("simple_pro_lifetime");
        this.doPurchase("simple_pro_yearly");

        Utilities.trackEvent("Subscription", "Subscription Restore Purchase Click");
    }

    async promoCode() {

        Utilities.trackEvent("Subscription", "Subscription Promo Code Click");

        let code = prompt("Enter Code")
        
        if (!code) {
            return;
        }
        
        code = code.toUpperCase();

        let res = await Server.redeemCode(code).catch(e => {
            window.toast((!e || !e.response ? "Failed to redeem" : e.response.status === 404 ? "Invalid Code" : e.response.status === 409 ? "This code has already been used, contact us if you you need help reseting it" : "Failed to redeem"), "error")
        });

        if (res && res.signature && res.validUntil) {
            if (new Date(res.validUntil*1000) < new Date()) {
                window.toast("Expired Code", "error")
            } else {
                await SQLStorage.saveSetting("promocode", res);
                await window.dropbox.queueForUpload("setting", "promocode");
                store.dispatch(updatedSetsSet(['null']))
                window.dropbox.debounce(true);
                localStorage.setItem("preventAppOpenTrack", "true")
                window.alert("Promo code applied and is valid until __".replace("__", Utilities.formatDate(new Date(res.validUntil*1000), "YYYY-MM-DD")), "success")
                window.location.reload();
            }
        }

    }

    async doPurchase(id) {
        if (!window.settings.account) {
            this.promptLogin();
            return
        }
        Utilities.trackEvent("Subscription", "Subscription Purchase Click");
        this.setState({ loading: true })
        window.store.order(id);
    }

    render() {

        const CONTENT = <IonContent style={{ '--background': '#617BE3' }}>
            <IonIcon className="close-btn" icon={closeCircle} onClick={() => { 
                if (this.props.modal) {
                    this.props.onClose();
                } else {
                    localStorage.setItem("preventAppOpenTrack", "true")
                    window.location.href = "/" 
                }
            }} />
            { (!this.state.activated) &&
                <div className="subscription">
                    <div>
                        <div className="logo">
                            <img src={Logo} />
                        </div>
                        <button className="chat-btn" onClick={() => { this.setState({ contactUsSheet: true }) }} >
                            <IonIcon icon={logoWhatsapp} />
                            Chat
                        </button>
                        <h2>{window.ln.subscriptionH}</h2>
                        <div className="list-2">
                            <div>
                                <h3>{window.ln.features}</h3>
                                <p>{window.ln.subFree}</p>
                                <p>{window.ln.subPro}</p>
                            </div>
                            <div>
                                <h3>{window.ln.subFreeUnlimited}</h3>
                                <p><IonIcon icon={checkmarkSharp} /></p>
                                <p><IonIcon icon={checkmarkSharp} /></p>
                            </div>
                            <div data-active={this.props.modal === "images"}>
                                <h3>{window.ln.images}</h3>
                                <p>10</p>
                                <p><IonIcon icon={infinite} /></p>
                            </div>
                            <div data-active={this.props.modal === "fields"}>
                                <h3>{window.ln.customFields}</h3>
                                <p>10</p>
                                <p><IonIcon icon={infinite} /></p>
                            </div>
                            <div data-active={this.props.modal === "links"}>
                                <h3>{window.ln.subLinks}</h3>
                                <p>10</p>
                                <p><IonIcon icon={infinite} /></p>
                            </div>
                            <div>
                                <h3>{window.ln.subPrint}</h3>
                                <p>20</p>
                                <p><IonIcon icon={infinite} /></p>
                            </div>
                            <div data-active={this.props.modal === "tags"}>
                                <h3>{window.ln.tags}</h3>
                                <p>3</p>
                                <p><IonIcon icon={infinite} /></p>
                            </div>
                            {/* <div data-active={this.props.modal === "notifications"}>
                                <h3>{window.ln.subNotifications}</h3>
                                <p>10</p>
                                <p>50</p>
                            </div> */}
                            <div data-active={this.props.modal === "setcards"}>
                                <h3>{window.ln.subCardsStudysets}</h3>
                                <p>500</p>
                                <p>3000</p>
                            </div>
                            <div data-active={this.props.modal === "imageCache"}>
                                <h3>{window.ln.imageCacheStudysetSub}</h3>
                                <p><IonIcon icon={close} /></p>
                                <p><IonIcon icon={checkmarkSharp} /></p>
                            </div>

                            <div data-active={this.props.modal === "context"}>
                                <h3>{window.ln.contextSearch} <span>({window.ln.supportedLangsVary})</span></h3>
                                <p>5</p>
                                <p><IonIcon icon={checkmarkSharp} /></p>
                            </div>
                            <div data-active={this.props.modal === "translation"}>
                                <h3>{window.ln.transalteSearch} <span>({window.ln.supportedLangsVary})</span></h3>
                                <p>5</p>
                                <p><IonIcon icon={checkmarkSharp} /></p>
                            </div>
                            <div data-active={this.props.modal === "synonym"}>
                                <h3>{window.ln.synonymSearch} <span>({window.ln.supportedLangsVary})</span></h3>
                                <p>5</p>
                                <p><IonIcon icon={checkmarkSharp} /></p>
                            </div>
                            
                            <div data-active={this.props.modal === "reviewschedule"}>
                                <h3>{window.ln.subRevisionCycles}</h3>
                                <p><IonIcon icon={close} /></p>
                                <p><IonIcon icon={checkmarkSharp} /></p>
                            </div>
                            
                            <div data-active={this.props.modal === "noads"}>
                                <h3>{window.ln.noAds}</h3>
                                <p><IonIcon icon={close} /></p>
                                <p><IonIcon icon={checkmarkSharp} /></p>
                            </div>

                            <div data-active={this.props.modal === "dupe"}>
                                <h3>{window.ln.dupeDetection}</h3>
                                <p><IonIcon icon={close} /></p>
                                <p><IonIcon icon={checkmarkSharp} /></p>
                            </div>

                            {/* <div data-active={this.props.modal === "reviewschedule"}>
                                <h3>{"AI Quiz Generator"}</h3>
                                <p><IonIcon icon={close} /></p>
                                <p><IonIcon icon={checkmarkSharp} /></p>
                            </div> */}

                            <div data-active={this.props.modal === "coffee"}>
                                <h3>{window.ln.coffeeFeature}</h3>
                                <p><IonIcon icon={close} /></p>
                                <p><IonIcon icon={checkmarkSharp} /></p>
                            </div>
                        </div>
                        {/* <div className="list">
                            <div>
                                <IonIcon style={{ fontSize: '3.6em' }} icon={heart} />
                                <p>{window.ln.subscriptionHEnd}</p>
                            </div>
                        </div> */}
                        <div 
                            className='coffee-for-us'
                            style={{
                                margin: '15px -30px 0 -30px'
                            }}
                        >
                            <img src={TeamSvg} />
                            { (this.state.lifetimePrice) &&
                                <p style={{ margin: '20px 20px 0px 20px', textAlign: 'center', fontWeight: 700 }}>
                                    {window.ln.coffeeForUs.replace("__", this.state.lifetimePrice)}
                                </p>
                            }
                        </div>
                        { !this.state.notAvailableInApp &&
                            <div className="options">
                                { (this.state.loading) &&
                                    <button className="main">
                                        <span><div class="lds-ring" style={{ position: 'relative', top: -6 }}><div></div><div></div><div></div><div></div></div></span>
                                    </button>
                                }
                                { (this.state.lifetimePrice) &&
                                    <button className="main" onClick={() => { this.doPurchase("simple_pro_lifetime") } }>
                                        <span>{window.ln.buyLifetimePro.replace("__", this.state.lifetimePrice)}</span>
                                    </button>
                                }
                                { (this.state.yearlyPrice) &&
                                    <button className="main" onClick={() => {
                                        this.doPurchase("simple_pro_yearly")
                                     } }>
                                        {/* // TODO LANG */}
                                        <span>{(window.ln.buyYearlyPro || "Buy Yearly Pro For __").replace("__", this.state.yearlyPrice)}</span>
                                    </button>
                                }
                            </div>
                        }
                        { (this.state.notAvailableInApp) &&
                            <div className="options" onClick={() => { this.setState({ contactUsSheet: true }) }} >
                                <button className="main" style={{ height: 'auto' }}>
                                    Your OS does not support In-App purcahses
                                </button>
                                <button onClick={() => { this.promoCode() }}>{window.ln.redeem.toUpperCase()}</button>
                            </div>
                        }
                        <div className="options">
                            <button onClick={() => {
                                if (this.state.notAvailableInApp) {
                                    window.toast(window.ln.licenceShareNew || "If you purchased a licence from another device you can share it with this device by logging into your account on both devices", "info");
                                } else {
                                    this.setState({
                                        clickedRestore: true
                                    })
                                    setTimeout(() => {
                                        this.setState({
                                            clickedRestore: false
                                        })
                                    }, 5000)
                                    this.attempToRestore()
                                }
                            }}>{window.ln.restorePurchase}</button>
                            <button onClick={() => { 
                                window.open("https://flashcardsmadesimple.com/terms")
                            }}>{window.ln.termsPrivacyC}</button>
                        </div>
                    </div>
                    <IonLoading
                        isOpen={this.state.fullScreenLoading}
                        message={"Loading..."}
                        duration={10000}
                    />
                </div>
            }
        </IonContent>

        if (this.props.modal) {
            return (
                <IonModal
                    isOpen={true}
                    swipeToClose={true}
                    presentingElement={/*this.props.modalRef.current*/null}
                    onDidDismiss={() => {
                        Utilities.onDrawerShow();
                        this.props.onClose();
                    }}
                    mode={"ios"}
                    data-modal="subscription"
                >
                    {CONTENT}
                </IonModal>
            )
        }

        return (
          <IonPage data-page="subscription">
              <IonHeader mode="ios">
                  <IonToolbar>
                      <IonTitle></IonTitle>
                  </IonToolbar>
              </IonHeader>
                    {CONTENT}
                    <IonActionSheet
                        isOpen={this.state.contactUsSheet}
                        onDidDismiss={() => { this.setState({ contactUsSheet: false }) }}
                        buttons={[
                            { text: "WhatsApp", handler: () => {
                                Utilities.trackEvent("Contact", "Contact by WhatsApp", "Subscription")
                                window.open("https://wa.me/36705359591?text=[App:FMS]")}
                            },
                            { text: "Email", handler: () => {
                                Utilities.trackEvent("Contact", "Contact by Email", "Subscription")
                                window.open("mailto:hello@chillnstudy.com?subject=[App:FMS]")}
                            },
                        ]}
                    />
               <IonFooter>
                   <IonToolbar>
                       <IonTitle></IonTitle>
                   </IonToolbar>
               </IonFooter>
          </IonPage>
        );
    }

};

export default withIonLifeCycle(Subscription);
